// ============================================================================
// FILE: EngineeringBOMStructuredView.js
// ============================================================================

import React, { useEffect, useState } from "react";
import axiosClient from "../../../../api/axiosClient";

export default function EngineeringBOMStructuredView({ bomId }) {

  const [baseLines, setBaseLines] = useState([]);
  const [derivedLines, setDerivedLines] = useState([]);
  const [materialMap, setMaterialMap] = useState({}); // 🔥 ADDED

  const [summary, setSummary] = useState({
    paintArea: 0,
    paintQty: 0,
    insArea: 0
  });

  useEffect(() => {
    loadData();
  }, [bomId]);

  const loadData = async () => {
  try {

    console.log("🔥 loadData START");

    const [res, matRes] = await Promise.all([
      axiosClient.get(`/api/ipe/boms/${bomId}/lines`),
      
      axiosClient.get(`/api/ppe/masters/raw-materials/all`)
    ]);
    //axiosClient.get(`/api/ppe/masters/raw-materials`)
    console.log("📦 BOM API RESPONSE:", res.data);
    console.log("📦 RAW MATERIAL API RESPONSE:", matRes.data);

    const lines = res.data.data || [];

    // 🔥 STEP 1: CHECK MATERIAL EXTRACTION
    let materials = [];

    if (Array.isArray(matRes.data?.data?.data)) {
      materials = matRes.data.data.data;
      console.log("✅ USING data.data");
    } else if (Array.isArray(matRes.data?.data)) {
      materials = matRes.data.data;
      console.log("✅ USING data");
    } else if (Array.isArray(matRes.data)) {
      materials = matRes.data;
      console.log("✅ USING ROOT ARRAY");
    } else {
      console.error("❌ UNKNOWN FORMAT", matRes.data);
    }

    console.log("📦 FINAL MATERIALS:", materials);

    // 🔥 STEP 2: BUILD MAP WITH DEBUG
    const map = {};

    materials.forEach(m => {
      console.log("➡️ MATERIAL ITEM:", m);

      const name = m.material_name || m.name || m.code;

      console.log("➡️ RESOLVED NAME:", name);

      if (m.id && name) {
        map[String(m.id)] = name;
      }
    });

    console.log("🧠 FINAL MAP:", map);

    setMaterialMap(map);

    const base = lines.filter(l => !l.is_auto_generated);
    const derived = lines.filter(l => l.is_auto_generated);

    console.log("📋 DERIVED LINES:", derived);

    // 🔥 STEP 3: TEST LOOKUP
    derived.forEach(d => {
      console.log(
        "🔎 LOOKUP:",
        d.material_id,
        "→",
        map[String(d.material_id)]
      );
    });

    setBaseLines(base);
    setDerivedLines(derived);

    let paintArea = 0;
    let insArea = 0;

    base.forEach(l => {
      if (l.painting_required) paintArea += Number(l.quantity) || 0;
      if (l.insulation_required) insArea += Number(l.quantity) || 0;
    });

    setSummary({
      paintArea,
      paintQty: paintArea / 8,
      insArea
    });

  } catch (err) {
    console.error("❌ ERROR:", err);
  }
};
  

  return (
    <div>

      {/* ===================================================== */}
      {/* BASE MATERIALS */}
      {/* ===================================================== */}
      <h5>BASE MATERIALS</h5>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Material</th>
            <th>Qty</th>
            <th>Painting</th>
            <th>Insulation</th>
          </tr>
        </thead>
        <tbody>
          {baseLines.map((l, i) => (
            <tr key={l.id}>
              <td>{i + 1}</td>

              <td>
                {l.material_name ||
                 materialMap[String(l.material_id)] ||
                 `ID: ${l.material_id}`}
              </td>

              <td>{l.quantity}</td>
              <td>{l.painting_required ? "Yes" : "No"}</td>
              <td>{l.insulation_required ? "Yes" : "No"}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ===================================================== */}
      {/* PAINT SUMMARY */}
      {/* ===================================================== */}
      <h5>🎨 PAINT CALCULATION SUMMARY</h5>

      <div className="card p-2 mb-3">
        <div>Total Paint Area: {summary.paintArea} Sq Ft</div>
        <div>Paint Required: {summary.paintQty.toFixed(2)}</div>
      </div>

      {/* ===================================================== */}
      {/* INSULATION SUMMARY */}
      {/* ===================================================== */}
      <h5>🧱 INSULATION CALCULATION SUMMARY</h5>

      <div className="card p-2 mb-3">
        <div>Total Insulation Area: {summary.insArea} Sq Ft</div>
      </div>

      {/* ===================================================== */}
      {/* DERIVED MATERIALS */}
      {/* ===================================================== */}
      <h5>DERIVED MATERIALS</h5>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Type</th>
            <th>Material</th>
            <th>Qty</th>
            <th>Source</th>
          </tr>
        </thead>
        <tbody>
          {derivedLines.map((l, i) => (
            <tr key={l.id}>
              <td>{i + 1}</td>
              <td>{l.process_type}</td>

              <td>
                {l.material_name ||
                 materialMap[String(l.material_id)] ||
                 `ID: ${l.material_id}`}
              </td>

              <td>{l.quantity}</td>
              <td>{l.process_type}</td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
}